module.exports = __webpack_public_path__ + "static/media/5. Manage approvals.2da6ad1a.svg";